// RequireAdmin.jsx
import { Navigate, useLocation } from "react-router-dom";
import { useEffect, useState } from "react";
import { API_DOMAIN } from "config";

function isAdmin(u) {
  if (!u) return false;
  const v = String(u.role ?? u.user_type ?? "").toLowerCase();
  return v === "admin" || v === "administrator" || v === "1";
}

export default function RequireAdmin({ currentUser, children }) {
  const location = useLocation();

  const [user, setUser] = useState(() => {
    const s = localStorage.getItem("currentUser");
    return currentUser ?? (s ? JSON.parse(s) : null);
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;

    async function check() {
      // יש לי כבר משתמש אדמין – לא צריך קריאת שרת
      if (isAdmin(user) || isAdmin(currentUser)) {
        if (!cancelled) {
          setUser(user || currentUser);
          setLoading(false);              // <<< חשוב!
        }
        return;
      }

      try {
        const res = await fetch(`${API_DOMAIN}/auth/me`, { credentials: "include" });
        if (res.ok) {
          const u = await res.json();
          if (!cancelled) {
            setUser(u);
            localStorage.setItem("currentUser", JSON.stringify(u));
          }
        } else {
          if (!cancelled) {
            setUser(null);
            localStorage.removeItem("currentUser");
          }
        }
      } catch (e) {
        console.error(e);
      } finally {
        if (!cancelled) setLoading(false);
      }
    }

    check();
    return () => { cancelled = true; };
    // חשוב: לא לשים `user` כתלות כדי לא להיכנס ללופ
  }, [currentUser]);

  if (loading) return <div className="fullscreen-loader">טוען…</div>;

  if (!isAdmin(user)) {
    // להפנות לעמוד התחברות, לא לנתיב אדמין
    return <Navigate to="/" replace state={{ from: location.pathname }} />;
  }

  return children;
}
